module.exports = __webpack_public_path__ + "img/05-alpha-2.e6b3ccc4.jpeg";